import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../Translations/LenguageContext";
import CryptoJS from "crypto-js";
import { BiCopy } from "react-icons/bi";

const ShareFileModal = ({ show, handleClose, filesToShare = [] }) => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const [copied, setCopied] = useState(false);

    const [secretKey, setSecretKey] = useState(null)

    const GetKey = async () => {
        try {
            const response = await fetch('https://backend.erioon.com/return_crptid', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const result = await response.json();
                setSecretKey(result.key)
            } else {
                console.error("Error fetching key:", response.statusText);
            }
        } catch (error) {
            console.error("Encryption key fetch failed", error);
        }
    }

    useEffect(() => {
        GetKey()
    }, []);


    const encryptData = (data) => {
        if (secretKey) {
            return CryptoJS.AES.encrypt(data, secretKey).toString();
        }
    };

    const fileIdsString = filesToShare.length > 0 ? filesToShare.join("_") : "";

    const encryptedData = encryptData(`${user_id}/${fileIdsString}`);

    // const fullLink = `http://localhost:3000/sf/${encryptedData}`;
    const fullLink = `https://www.erioon.com/sf/${encryptedData}`;

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(fullLink);
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} className="modal_share">
            <div className="share_main_cont_modal">
                <p className="share_label">{t.cloud.share} {filesToShare.length} {filesToShare.length == 1 ? "file" : "files"}?</p>
                <div className="share_link_cont_modal">
                    <p className="warning_delete_message">
                        {t.cloud.warning_mex_share}
                    </p>
                    <div className="link_cont_file_share">
                        <div className="link_file">
                            <p>
                                {secretKey ? (
                                    fullLink 
                                ) : (
                                    <div className="loading_link_container"></div>
                                )}
                            </p>
                        </div>
                        <button className="copy_clipboard_link_file_btn" onClick={copyToClipboard}>
                            {copied ? <i className="fa-solid fa-check"></i> : <BiCopy />}
                        </button>
                    </div>
                </div>
            </div>
            <div className="modal_footer">
                <div className="footer_btn_cont">
                    <button className="cancel_btn" onClick={handleClose}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ShareFileModal;
